import { render, staticRenderFns } from "./form_change_star_component.vue?vue&type=template&id=699d7f14&scoped=true"
import script from "./form_change_star_component.vue?vue&type=script&lang=js"
export * from "./form_change_star_component.vue?vue&type=script&lang=js"
import style0 from "./form_change_star_component.vue?vue&type=style&index=0&id=699d7f14&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699d7f14",
  null
  
)

export default component.exports